
import {
  Typography,
  Grid,
  Box, Avatar
} 
from "@mui/material"; 
import { darkcolor, orangecolor, pcolor, rcolor, whitecolor } from "../../style2";



// const useStyles = makeStyles((theme) => ({
//   name: {
//     fontWeight: "bold",
//     fontSize: 16,
//     color: pcolor,
//   },
//   profession: {
//     fontWeight: "bold",
//     fontSize: 14,
//     color: "#001244",
//   },
//   hospital: {
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "#001244",
//   },
//   email: {
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "#001244",
//   },
//   mailicon: {
//     color: rcolor,
//   },
//   avatar: {
//     background: "#4bc0a9",
//   },
//   listitembutton: {
//     "&:hover": {
//       color: "#EBEEFF",
//     },
//   },

// }));

const name = {
  fontWeight: "bold",
  fontSize: 16,
  color: pcolor,
};

const profession = {
  fontWeight: "bold",
  fontSize: 14,
  color: "#001244",
};

const hospital = {
  fontWeight: "normal",
  fontSize: 14,
  color: "#001244",
};

const email = {
  fontWeight: "normal",
  fontSize: 14,
  color: "#001244",
};

const mailicon = {
  color: rcolor,
};

const avatar = {
  background: "#4bc0a9",
};

const listitembutton = {
  "&:hover": {
    color: "#EBEEFF",
  },
};

function Careteamlist({
  Title,
  FirstName,
  LastName,
  Linked,
  Profession,
  Hospital,
  Email,
  Service,
  IsOrganizationProfessional,
  Organization,
  Pathways
}) {
  //const classes = useStyles();

  return (
    <Box sx={{ paddingX: 3, my: 2 }}>
      <Box sx={{...listitembutton, width: '100%' }} >
        <Grid container spacing={2} alignItems='center'>
          <Grid item>
            <Avatar aria-label='recipe' sx={{...avatar, fontSize: "2rem", fontWeight: "normal", width: "60px", height: "60px", backgroundColor: pcolor }}>
              {FirstName.charAt(0)}
            </Avatar>
          </Grid>
          <Grid item xs={10} container direction='column' spacing={2}>
            <Grid item xs>
              <Typography sx={{ ...name, fontWeight: "normal", fontSize: "17px" }}>
                {FirstName}
              </Typography>
              <Typography sx={{ ...profession, color: darkcolor, fontSize: "14px" }}>
                {Title}
              </Typography>
              {Hospital ? <Typography sx={{ ...hospital, color: darkcolor, fontSize: "14px" }}>{Hospital}</Typography> : null}
              {Service ? <Typography sx={{ ...hospital, color: darkcolor, fontSize: "14px", marginTop: "3px" }}>Service/Department: {Service}</Typography> : null}
              {IsOrganizationProfessional ? Organization !== null ? <Typography sx={{ ...hospital, color: darkcolor, fontSize: "16px", marginTop: "5px" }}>Organisation: {Organization.name}</Typography> : null : null}
              {IsOrganizationProfessional && Pathways && Pathways.length ? <Box sx={{ marginTop: "5px" }}>
                <Typography sx={{...hospital, display:"inline-block", color: darkcolor, fontSize: "14px", marginRight:"5px" }}>Pathways: </Typography>
                  {Pathways.map(p => { return <Box component="span" sx={{display:"inline-block", fontWeight:"normal", fontSize: "14px", marginRight:"5px", padding:"3px 10px", borderRadius:"10px", backgroundColor:orangecolor, color: whitecolor}}>{p.name}</Box>})}
              </Box> : null}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box style={{ marginTop: "10px", marginBottom: "6px", border: "1px solid #F1EFDF" }} />
    </Box>
  );
}

export default Careteamlist;
